module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-card/template.html
 ** module id = 395
 ** module chunks = 1
 **/